import { useEffect, useRef, useState } from "react";
// for Accordion starts
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
// for Accordion ends
import { PRODUCTS_INDEX } from "@constant/common";
import { PDP_NO_IMAGE } from "@constant/noImage";
import { PRODUCT } from "@constant/types";
import { QUOTE_REQUEST_TO_OWNER, QUOTE_REQUEST_TO_USER } from "@constant/whatsappTemplates";
import { disableLoader, enableLoader, showError, showSuccess, updatePdpItem, updatePdpItemStatus, updateStore, updateWhatsappTemplates } from "@context/actions";
import CustomeImageSlider from "@element/customeImageSlider";
import ImageSlider from "@element/imageSlider";
import Backdrop from '@material-ui/core/Backdrop';
import UserRegistrationModal from "@module/userRegistration";
import { markStoreOptInForWhatsapp } from "@storeData/store";
import { markUserOptInForWhatsapp } from "@storeData/user";
import { getAllTemplates, markUserOptIn, sendWhatsappMsgMessage } from "@storeData/whatsapp";
import { APISERVICE } from "@util/apiService/RestClient";
import { navigateTo, navigateToBack, sanitizeRoutePath } from '@util/routerService';
import { isActiveAtBinaryIndex, processTaxList } from "@util/utils";
import { windowRef } from "@util/window";
import { replaceOrderIitems } from "app/redux/actions/order";
import { useRouter } from 'next/router';
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from 'react-redux';

import {
  BiZoomIn,
  BiZoomOut,
  CameraIcon,
  CartIcon,
  CloseIcon,
  CloseLargeIcon,
  CopyClipboardIcon,
  ExpandIcon,
  FacebookBrandIcon,
  IconFrame,
  ShareIcon,
  WhatsappBrandIcon,
} from '@element/icons';
const shareIconList = [
    {
        name: 'Whatsapp',
        icon: <WhatsappBrandIcon />
    },
    {
        name: 'Facebook',
        icon: <FacebookBrandIcon />
    },
    {
        name: 'Copy Link',
        icon: <CopyClipboardIcon />
    },
    // {
    //     name: 'Telegram',
    //     icon: "/assets/Icons/social/telegram.png"
    // },
    // {
    //     name: 'Twitter',
    //     icon: "/assets/Icons/social/twitter.png"
    // },
    // {
    //     name: 'Instagram',
    //     icon: "/assets/Icons/social/instagram.png"
    // }, 
    // {
    //     name: 'Linkedin',
    //     icon: "/assets/Icons/social/linkedin.png"
    // },
]

function PdpModal() {
    const router = useRouter();
    const [quantity, setQuantity] = useState(0);
    const [total, setTotal] = useState(0);
    const store = useSelector((state: any) => state.store);
    const state = useSelector((state: any) => state);
    const activeLanguage: any = state.activeLanguage
    const dispatch = useDispatch();
    const whatsappTemplates = store.whatsappTemplates;
    const cartItems = useSelector((state: any) => state.orderItems);
    const item = useSelector((state: any) => state.pdpItem);
    // const [itemDetails, setItemDetails] = useState(item)
    const pdpItemStatus = useSelector((state: any) => state.pdpItemStatus);
    const itemStock = useSelector((state: any) => state.itemStock);
    const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
    const [activeVariation, setActiveVariation] = useState((item?.variations && item?.variations?.length !== 0) ? item?.variations[0] : null);
    const { configData, keywords } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const gupshupConfig = configData?.storeConfig?.gupshupConfig;
    const [availableWidth, setAvailableWidth] = useState(400);
    const [showLongDescription, setShowLongDescription] = useState(false);
    const alreadyShortDescription = item?.description <= item?.description?.substring(0, 90);
    const shortDescription = (item?.languages && item.languages[activeLanguage?.languageId]?.description) ? item.languages[activeLanguage?.languageId]?.description : (item?.description ? item?.description?.substring(0, 90) : '');
    const [showVdoModal, setShowVdoModal] = useState(false)
    const [descList, setDescList] = useState(item?.description ? item?.description?.split('||') : []);
    const storeMetaData = useSelector((state: any) => state.store ? state.store.storeMetaData : null);
    const [cookie, setCookie] = useCookies();
    const [userData, setUserData] = useState(cookie['user']);
    const [quoteReqSubmitted, setquoteReqSubmitted] = useState(false);
    const [showUserRegistrationModal, setShowUserRegistrationModal] = useState(false)
    const [cartItemQuantity, setCartItemQuantity] = useState(0);
    const [openShareModal, setOpenShareModal] = useState(false);
    const modalRef = useRef(null);
    const [currentStock, setCurrentStock] = useState<any>(0)
    const storeData = useSelector((state: any) => state.store.storeData);
    const languageData: any = state.languageKeywords
    const hideProductSeoUrls = configData?.storeConfig?.sparkConfig?.hideProductSeoUrls;

    router?.events?.on('routeChangeStart', (newRoute) => {
        if (!newRoute.includes('-pdp')) {//if on browser back click remove pdp element// here check is added because we cant get previous url 
            closePdpModal()
        }
    });

    // useEffect(() => {
    //     const categoriesData = storeData.categories;
    //     let itemDetails = null;
    //     if (item) {
    //         if (categoriesData.length != 0) {
    //             categoriesData.map((c) => {
    //                 if (c && c.categoryList && c?.categoryList?.length != 0) {
    //                     c.categoryList.map((sc) => {
    //                         if (!Boolean(itemDetails)) itemDetails = sc.itemList.find((i) => i.name.toLowerCase() == (item.name).toLowerCase());
    //                     })
    //                 } else {
    //                     if (!Boolean(itemDetails)) itemDetails = c.itemList.find((i) => i.name.toLowerCase() == (item.name).toLowerCase());
    //                 }
    //             })
    //         }
    //     }
    //     Boolean(itemDetails) && (setItemDetails({ ...item, ...itemDetails, test: "done" }));
    // }, [item])

    useEffect(() => {
        if (cartItems && cartItems.length && windowRef) {
            let qty = 0;
            cartItems.map((cartItem) => qty += cartItem.quantity)
            if (cartItemQuantity != qty) {
                setCartItemQuantity(qty);
                let element = document.getElementById('cart-item-count-pdp')
                if (element) {
                    element.classList.add("shake")
                    setTimeout(() => {
                        element.classList.remove("shake")
                    }, 1000);
                }
            }
        } else setCartItemQuantity(0);
    }, [cartItems])

    useEffect(() => {
        if (cookie['user']) {
            setUserData(cookie['user'])
        }
    }, [cookie])

    useEffect(() => {
        if (windowRef && item) {
            if (item && cookie[item.id] == item.id) setquoteReqSubmitted(true)
            else setquoteReqSubmitted(false)
            if (!configData?.storeConfig?.sparkConfig?.showThumbnailsOnPDP) {
                document.getElementById("prod-img").style.width = "100%";
                windowRef.availWidth = window?.screen?.availWidth
            }
            setTimeout(() => {
                const defaultWrapperElement: any = document.getElementsByClassName('default-wrapper');
                const mainheaderblock: any = document.getElementsByClassName('mainheaderblock');
                if (item) {
                    document.body.classList.add("o-h")
                    if (item.type == keywords.product) {
                        mainheaderblock[0]?.classList?.add("hide")
                        defaultWrapperElement[0]?.classList?.add("hide")
                    }
                } else {
                    closePdpModal()
                }
            }, 0);
            setAvailableWidth(window?.screen?.availWidth > 480 ? 480 : window?.screen?.availWidth);
            setActiveVariation((item?.variations && item?.variations?.length !== 0) ? item?.variations[0] : null)
            if (item?.description?.includes('||')) {
                setDescList(item?.description?.split('||'))
            }
            if (item.type == 'product') {
                let itemUrl = item?.itemUrl;
                if (!itemUrl) {
                    itemUrl = item.name.toLowerCase().split(" ").join("-") + '-pdp';
                    const pagepath = ('pagepath' in router.query) ? router.query.pagepath[0] : 'home'
                    itemUrl = pagepath + "/" + itemUrl;
                }
                !Boolean(hideProductSeoUrls) && router.push(sanitizeRoutePath(baseRouteUrl + itemUrl), '', { shallow: true })
            }
        }
    }, [item, windowRef]);

    useEffect(() => {
        if (item && configData?.storeConfig?.basicConfig?.inventory && !router.asPath.includes('cart')) {
            let stock = 0;
            if (activeVariation) {
                stock = itemStock[`${item.id}${activeVariation.id}`] || 0;
            } else {
                stock = itemStock[item.id] || 0;
            }
            setCurrentStock(stock)
        }
    }, [item, activeVariation, itemStock])

    useEffect(() => {
        let totalcopy = 0;
        let quantityCopy = 0;
        if (cartItems && cartItems.length && item) {
            const itemIndex: number = cartItems.findIndex((cartItem) => (cartItem.name == item?.name && cartItem.categoryName == item?.categoryName) && ((cartItem.variations) ? (cartItem.variations[0].name == activeVariation?.name) : true));
            if (itemIndex != -1) {
                totalcopy = cartItems[itemIndex].quantity * (cartItems[itemIndex].salePrice || cartItems[itemIndex].price);
                quantityCopy = cartItems[itemIndex].quantity;
            }
        }
        setTotal(totalcopy);
        setQuantity(quantityCopy);
    }, [cartItems, activeVariation, item])

    const closePdpModal = () => {
        const defaultWrapperElement: any = document.getElementsByClassName('default-wrapper');
        const mainheaderblock: any = document.getElementsByClassName('mainheaderblock');
        document.body.classList.remove("o-h")
        mainheaderblock[0]?.classList?.remove("hide")
        defaultWrapperElement[0]?.classList?.remove("hide")
        dispatch(updatePdpItem(null));
        dispatch(updatePdpItemStatus(null));
    }

    const onSharePage = async () => {
        if (window.navigator.share) {
            try {
                const catUrl = item.categoryName.toLowerCase().split(" ").join("-") + '-prp/';
                const itemUrl = catUrl + item.name.toLowerCase().split(" ").join("-") + '-pdp';

                await window.navigator.share({ title: `${item.name}`, url: `${storeMetaData.sUrl}/${itemUrl}` });
            } catch (err) {
                // setOpenShareModal(true)
                console.error("Share failed:", err.message);
            }
        } else setOpenShareModal(true)
    }

    const calculateTaxes = (taxebalePrice: any, quantity: number, taxCharges: any) => {
        const hasTaxCharges = Boolean(taxCharges?.length);
        const taxesToProcess = hasTaxCharges ? taxCharges : (configData.txchConfig || []);
        const taxList = taxesToProcess
            .filter(taxData =>
                taxData.active &&
                (hasTaxCharges || (isActiveAtBinaryIndex(taxData.applyOn, PRODUCTS_INDEX) && !taxData.charge))
            );

        const txchrgs = processTaxList(taxList, taxebalePrice, quantity);
        return txchrgs;
    };

    const addQuantity = () => {
        const cartItemsCopy = cartItems ? [...cartItems] : [];
        const itemIndex: number = cartItemsCopy.findIndex((cartItem) => (cartItem.name == item?.name && cartItem.categoryName == item?.categoryName) && ((cartItem.variations) ? (cartItem.variations[0].name == activeVariation?.name) : true));
        if (cartItemsCopy[itemIndex].quantity == currentStock) {
            const element: any = document.getElementById('current-stock-wrap');
            if (element) {
                element.classList.add("shake")
                setTimeout(() => {
                    element.classList.remove("shake")
                }, 500);
            }
        } else {
            cartItemsCopy[itemIndex].quantity = cartItemsCopy[itemIndex].quantity + 1;
            cartItemsCopy[itemIndex].txchrgs = calculateTaxes((cartItemsCopy[itemIndex].salePrice || cartItemsCopy[itemIndex].price), cartItemsCopy[itemIndex].quantity, cartItemsCopy[itemIndex].taxCharges)
            dispatch(replaceOrderIitems(cartItemsCopy));
            dispatch(showSuccess(`${languageData['Product Added'] ? languageData['Product Added'] : 'Product Added'}`, 2000));
        }
    }

    const removeQuantity = () => {
        const cartItemsCopy = cartItems ? [...cartItems] : [];
        if (quantity == 1) {
            const itemIndex: number = cartItemsCopy.findIndex((cartItem) => (cartItem.name == item?.name && cartItem.categoryName == item?.categoryName) && ((cartItem.variations) ? (cartItem.variations[0].name == activeVariation?.name) : true));
            cartItemsCopy.splice(itemIndex, 1);
            dispatch(replaceOrderIitems(cartItemsCopy));
        } else {
            const itemIndex: number = cartItemsCopy.findIndex((cartItem) => (cartItem.name == item?.name && cartItem.categoryName == item?.categoryName) && ((cartItem.variations) ? (cartItem.variations[0].name == activeVariation?.name) : true));
            cartItemsCopy[itemIndex].quantity = cartItemsCopy[itemIndex].quantity - 1;
            cartItemsCopy[itemIndex].txchrgs = calculateTaxes((cartItemsCopy[itemIndex].salePrice || cartItemsCopy[itemIndex].price), cartItemsCopy[itemIndex].quantity, cartItemsCopy[itemIndex].taxCharges)
            dispatch(replaceOrderIitems(cartItemsCopy));
        }
        dispatch(showSuccess(`${languageData['Product Removed'] ? languageData['Product Removed'] : 'Product Removed'}`, 2000));
    }

    const addItemToCart = () => {
        const cartItemsCopy = cartItems ? [...cartItems] : [];
        if (activeVariation) {
            const cartItem = {
                "name": item.name,
                "id": item?.id,
                "category": item?.categoryName,
                "categoryId": item?.categoryId,
                "price": activeVariation?.price,
                "salePrice": activeVariation?.salePrice,
                "quantity": 1,
                "remark": null,
                "imagePaths": item?.imagePaths,
                "txchrgs": [],
                "variations": [{
                    "id": activeVariation?.id,
                    "name": activeVariation?.name,
                    "price": activeVariation?.price,
                    "salePrice": activeVariation?.salePrice
                }],
                "languages": item.languages,
                "skuCode": activeVariation.itemIdentificationCode,
                "taxCharges": item?.taxCharges

            }
            cartItem.txchrgs = calculateTaxes((cartItem.salePrice || cartItem.price), cartItem.quantity, cartItem.taxCharges)
            cartItemsCopy.push(cartItem);
            dispatch(replaceOrderIitems(cartItemsCopy));
            dispatch(showSuccess(`${languageData['Product Added'] ? languageData['Product Added'] : 'Product Added'}`, 2000));
        } else {
            const cartItem = {
                "name": item.name,
                "id": item?.id,
                "categoryName": item?.categoryName,
                "price": item?.price,
                "salePrice": item?.salePrice,
                "quantity": 1,
                "remark": null,
                "imagePaths": item?.imagePaths,
                "variations": null,
                "category": item?.categoryName,
                "categoryId": item?.categoryId,
                "txchrgs": [],
                "taxCharges": item?.taxCharges
            }
            cartItem.txchrgs = calculateTaxes((cartItem.salePrice || cartItem.price), cartItem.quantity, cartItem.taxCharges)
            cartItemsCopy.push(cartItem);
            dispatch(replaceOrderIitems(cartItemsCopy));
            dispatch(showSuccess(`${languageData['Product Added to Cart'] ? languageData['Product Added to Cart'] : 'Product Added to Cart'}`, 2000));
        }
    }

    const zoom = (status) => {
        const zoomPer = 20;
        var element = document.getElementById("prod-img");
        const percent: any = (element.clientWidth / document.body.clientWidth * 100);
        const width: any = percent.toFixed() / 10;
        const currentPerWidth: any = Number(parseInt(width, 10) * 10);
        if (status == 'in' && (currentPerWidth <= 160)) document.getElementById("prod-img").style.width = (currentPerWidth + zoomPer) + "%";
        else if (status == 'out') {
            if (currentPerWidth >= 100) {
                document.getElementById("prod-img").style.width = (currentPerWidth - zoomPer) + "%";
            }
            if (currentPerWidth - zoomPer < 100) document.getElementById("prod-img").style.width = "100%";
        }
    }

    const checkForOptIn = (type: any, typeDetails: any) => {
        return new Promise((res, rej) => {
            if (type.optInForWapp) res(true)
            else {
                markUserOptIn(gupshupConfig, type.number).then(() => {
                    //update in db
                    if (type.from == 'user') {
                        markUserOptInForWhatsapp(storeMetaData.tenantId, storeMetaData.id, [type.number]).then(() => {
                            const userDeta = { ...typeDetails, optInForWapp: true }
                            setCookie("user", userDeta, { //user registration fields
                                path: "/",
                                expires: new Date(new Date().setSeconds(new Date().getFullYear() + 1)),
                                sameSite: true,
                            })
                        })
                    } else {
                        markStoreOptInForWhatsapp(storeMetaData.tenantId).then(() => {
                            const storeCopy = { ...store }
                            storeCopy.storeMetaData.optInForWapp = true;
                            dispatch(updateStore({ ...storeCopy }));
                        })
                    }
                    res(true);
                })
            }
        })
    }

    const sendReqMessageToUser = (templates: any[], user: any) => {
        const template = templates.filter((t: any) => t.elementName == QUOTE_REQUEST_TO_USER);
        const catUrl = item.categoryName.toLowerCase().split(" ").join("-") + '-prp/';
        const itemUrl = catUrl + item.name.toLowerCase().split(" ").join("-") + '-pdp';
        let itemmsg = `${item.categoryName}- ${item.name}`;
        // if (activeVariation) {
        //     itemmsg = `${item.categoryName} - ${item.name}, price ${activeVariation.salePrice || activeVariation.price}, ${activeVariation.name} `
        // }
        const templObj: any = {
            id: template[0].id,
            params: [user.firstName, (storeMetaData.name + storeMetaData.businessType ? (" " + storeMetaData.businessType) : ""), `${itemmsg}`, storeMetaData.phone, `${storeMetaData.sUrl}/${itemUrl}`]
        }
        const body = {
            template: JSON.stringify(templObj),
            source: 91 + gupshupConfig.number,
            destination: 91 + user.mobileNo,
        }
        sendWhatsappMsgMessage(gupshupConfig, body).then(() => {
            // dispatch(showSuccess('Quote request send successfully', 2000));
        }).catch((err) => {
            // dispatch(showError('Quote request sending failed'))
            console.error(err)
        })
    }

    const sendReqMessageToOwner = (templates: any[], user: any) => {
        const template = templates.filter((t: any) => t.elementName == QUOTE_REQUEST_TO_OWNER);
        const catUrl = item.categoryName.toLowerCase().split(" ").join("-") + '-prp/';
        const itemUrl = catUrl + item.name.toLowerCase().split(" ").join("-") + '-pdp';
        let itemmsg = `${item.categoryName}- ${item.name}`;
        // if (activeVariation) {
        //     itemmsg = `${item.categoryName} - ${item.name}, price ${activeVariation.salePrice || activeVariation.price}, ${activeVariation.name} `
        // }
        const templObj: any = {
            id: template[0].id,
            params: [(storeMetaData.name + storeMetaData.businessType ? (" " + storeMetaData.businessType) : ""), user.firstName, user.mobileNo, `${itemmsg}`, `${storeMetaData.sUrl}/${itemUrl}`]
        }
        const body = {
            template: JSON.stringify(templObj),
            source: 91 + gupshupConfig.number,
            destination: 91 + storeMetaData.phone1
            // destination: 91 + user.mobileNo,
        }
        dispatch(enableLoader());
        checkForOptIn({ from: 'store', number: storeMetaData.phone, optInForWapp: storeMetaData.optInForWapp }, storeMetaData).then(() => {
            sendWhatsappMsgMessage(gupshupConfig, body).then(() => {
                dispatch(showSuccess(`${languageData['Quote request send successfully'] ? languageData['Quote request send successfully'] : 'Quote request send successfully'}`, 2000));
                setCookie(`${item.id}`, item.id, {
                    path: "/",
                    expires: new Date(new Date().setHours(new Date().getHours() + 30)),
                    sameSite: true,
                })
                setquoteReqSubmitted(true)
                checkForOptIn({ from: 'user', number: user.mobileNo, optInForWapp: user.optInForWapp }, user).then(() => {
                    sendReqMessageToUser(templates, user);
                })
                dispatch(disableLoader());
            }).catch((err) => {
                dispatch(showError(`${languageData['Quote request sending failed'] ? languageData['Quote request sending failed'] : 'Quote request sending failed'}`))
                console.error(err)
                dispatch(disableLoader());
            })
        })
    }

    const checkForUser = () => {
        if (userData && userData.firstName) {
            sendQuoteRequest(userData);
        } else {
            setShowUserRegistrationModal(true);
        }
    }

    const sendQuoteRequest = (user: any) => {
        if (gupshupConfig.active) {
            if (whatsappTemplates && whatsappTemplates?.length != 0) {
                sendReqMessageToOwner(whatsappTemplates, user)
            } else {
                getAllTemplates(gupshupConfig)
                    .then((res: any) => {
                        if (res) {
                            dispatch(updateWhatsappTemplates(res));
                            sendReqMessageToOwner(res, user)
                        }
                        else {
                            dispatch(showError(`${languageData['Quote request sending failed'] ? languageData['Quote request sending failed'] : 'Quote request sending failed'}`))
                            dispatch(disableLoader());
                        }
                    })
                    .catch((err: any) => {
                        dispatch(showError(`${languageData['Quote request sending failed'] ? languageData['Quote request sending failed'] : 'Quote request sending failed'}`))
                        dispatch(disableLoader());
                        console.error(err)
                    })
            }
        } else {
            dispatch(enableLoader());
            const catUrl = item.categoryName.toLowerCase().split(" ").join("-") + '-prp/';
            const itemUrl = catUrl + item.name.toLowerCase().split(" ").join("-") + '-pdp';
            const apiBody = {
                shopName: store?.store?.storeData?.tenant + storeMetaData.name,
                custName: user.firstName,
                custNumber: user.mobileNo,
                itemName: `${item.categoryName}- ${item.name}`,
                storeName: storeMetaData.name,
                storeNumber: storeMetaData.phone1,
                storeId: storeMetaData.id,
                tenantId: storeMetaData.tenantId,
                itemUrl: `${storeMetaData.sUrl}/${itemUrl}`,
                shopUrl: `${storeMetaData.sUrl}`
            }
            APISERVICE.POST(`${process.env.NEXT_PUBLIC_PCS_TXN}/quotation/customer/owner`, apiBody).then((res) => {
                dispatch(showSuccess(`${languageData['Quote request send successfully'] ? languageData['Quote request send successfully'] : 'Quote request send successfully'}`, 2000));
                setCookie(`${item.id}`, item.id, {
                    path: "/",
                    expires: new Date(new Date().setHours(new Date().getHours() + 30)),
                    sameSite: true,
                })
                setquoteReqSubmitted(true)
                dispatch(disableLoader());
            }).catch((err) => {
                dispatch(showError(`${languageData['Quote request send failed, please try after some time.'] ? languageData['Quote request send failed, please try after some time.'] : 'Quote request send failed, please try after some time.'}`, 2000));
                console.error(err)
                dispatch(disableLoader());
            })
        }
    }

    const onLoginClose = (user) => {
        if (user) {
            setUserData(user);
            sendQuoteRequest(user);
        }
        setShowUserRegistrationModal(false);
    }

    const onClickSocialIcon = (linkData) => {
        const itemUrl = window.location.href + '/' + item.name.toLowerCase().split(" ").join("-") + '-pdp';
        switch (linkData.name) {
            case 'Facebook':
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${itemUrl}`, '_blank');
                break;
            case 'Twitter':
                window.open(`https://twitter.com/intent/tweet?text=${item.pTitle || item.name}&url=${itemUrl}`, '_blank');
                break;
            case 'Whatsapp':
                window.open(`https://api.whatsapp.com/send?text=${item.pTitle || item.name} ${itemUrl}`, '_blank');
                break;
            case 'Instagram':
                window.open(`https://www.instagram.com/?url=${itemUrl}`, '_blank');
                break;
            case 'Linkedin':
                window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${itemUrl}`, '_blank');
                break;
            case 'Telegram':
                window.open(`https://telegram.me/share/msg?url=${item.pTitle || item.name}&url=${itemUrl}`, '_blank');
                break;
            case 'Copy Link':
                window?.navigator?.clipboard?.writeText(decodeURIComponent(itemUrl));
                dispatch(showSuccess(`${languageData["Copied successfully"] ? languageData["Copied successfully"] : "Copied successfully"}`));
                setOpenShareModal(false);
                break;
            default:
                break;
        }
    }

    const onOutsideClick = (event: any) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            closePdpModal();
        }
    }

    const onClose = () => {
        !Boolean(hideProductSeoUrls) && navigateToBack(baseRouteUrl);
        closePdpModal();
    }

    return (
        <>
            <div className="pdp-modal-wrap "
                onClick={onOutsideClick}
                style={{
                    height: `${(item && item.type == keywords[PRODUCT]) ? 'calc(100vh - calc(100vh - 100%))' : 0}`,
                    overflow: `${(item && item.type == keywords[PRODUCT]) ? 'unset' : 'hidden'}`,
                    maxHeight: `${(item && item.type == keywords[PRODUCT]) ? 'calc(100vh - calc(100vh - 100%))' : 0}`,
                    backgroundColor: '#0000001f'
                }}>
                <div className="pdp-page-content" ref={modalRef} >
                    <div className="action-btn-wrap">
                        <div className="modal-close" onClick={() => onClose()}>
                            <IconFrame><CloseIcon /></IconFrame>
                        </div>
                        <div className="secondary-action">
                            {(configData?.orderingOn && !configData?.storeOff && !configData?.readOnlyMenu && !!cartItemQuantity) && <div className="modal-close modal-cart" id="cart-item-count-pdp" onClick={() => navigateTo('cart')}>
                                <div className="cart-item-count">{cartItemQuantity}</div>
                                <IconFrame><CartIcon /></IconFrame>
                            </div>}
                            {/* {windowRef() && window?.location?.protocol == 'https:'
                                && <div className="modal-close modal-share" onClick={() => onSharePage()}>
                                    <IconFrame><ShareIcon /></IconFrame>
                                </div>} */}
                            {item?.videoLink && !(configData?.storeConfig?.sparkConfig?.showThumbnailsOnPDP) && <div className="modal-close vdo-icon" onClick={() => setShowVdoModal(true)}>
                                <IconFrame><CameraIcon /></IconFrame>
                            </div>}
                        </div>

                    </div>
                    {item && <div className="prodpdpbanner">
                        {/* <div className="modal-close zoom-out" onClick={() => zoom('out')}>{BiZoomOut()}</div>
                            <div className="modal-close zoom-in" onClick={() => zoom('in')}>{BiZoomIn()}</div> */}
                        {configData?.storeConfig?.sparkConfig?.showThumbnailsOnPDP ? <>
                            <CustomeImageSlider item={item} />
                        </> : <div className="slider-wrap">
                            <div className="zoom-div" id="prod-img" style={{ width: '100%' }}>
                                <ImageSlider itemsList={item?.imagePaths} config={{ redirection: false }} no_image={PDP_NO_IMAGE} />
                            </div>
                        </div>}
                    </div>}
                    <div className="prod-pdp-details clearfix">
                        {/* <div className="prod-pdp-off">15% OFF</div> */}
                        <div className="prod-pdp-nameprice clearfix">
                            {/* <div className="prod-pdp-cat-name">{item?.categoryName}</div> */}
                            <div className="prod-pdp-name">{item?.languages && item.languages[activeLanguage?.languageId]?.name ? item.languages[activeLanguage?.languageId]?.name : item?.name}</div>
                            <div className="prod-pdp-price">
                                {item?.variations?.length != 0 ? <>
                                    <>
                                        {activeVariation?.salePrice == 0 ?
                                            <div className="prod-sale-price">
                                                {configData.currencySymbol}{activeVariation?.price}
                                            </div> :
                                            <div className="prod-sale-price">
                                                <span>{configData.currencySymbol}{activeVariation?.price}</span>
                                                {configData.currencySymbol}{activeVariation?.salePrice}
                                            </div>
                                        }
                                    </>
                                </> :
                                    <>
                                        {item?.salePrice == 0 ?
                                            <div className="prod-sale-price">
                                                {configData.currencySymbol}{item?.price}
                                            </div> :
                                            <div className="prod-sale-price">
                                                <span>{configData.currencySymbol}{item?.price}</span>{configData.currencySymbol}{item?.salePrice}
                                            </div>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                        {item?.description && item?.description?.includes('||') ? <>
                            {descList.map((desc: any, i: number) => {
                                return <div className="serv-pdp-servtypedesc serv-pdp-servtypedesc-list" key={Math.random()}><span>&#8226;</span>{desc} </div>
                            })
                            }
                        </> : <>
                            {item?.description && <>
                                {alreadyShortDescription && <>
                                    <div className="serv-pdp-servtypedesc">{item?.languages && item.languages[activeLanguage?.languageId]?.description ? item.languages[activeLanguage?.languageId]?.description : item?.description}</div>
                                </>}
                                {!alreadyShortDescription && <>
                                    {showLongDescription && <div className="serv-pdp-servtypedesc" onClick={() => setShowLongDescription(false)}>
                                        {item?.languages && item.languages[activeLanguage?.languageId]?.description ? item.languages[activeLanguage?.languageId]?.description : item?.description}
                                        <span>{languageData["Read Less"] ? languageData["Read Less"] : "Read Less"}</span>
                                    </div>}
                                    {!showLongDescription && <div className="serv-pdp-servtypedesc" onClick={() => setShowLongDescription(true)}>
                                        {shortDescription}...
                                        <span>{languageData["Read More"] ? languageData["Read More"] : "Read More"}</span>
                                    </div>}
                                </>}
                            </>}
                        </>}

                        {(item?.variations && item?.variations?.length !== 0) && <div className="prod-pdp-size">
                            {item?.variations?.filter((variation: any) => Boolean(variation.isRetail)).map((variant, variantIndex) => {
                                return <div key={variantIndex}>
                                    <span className={activeVariation?.name === variant.name ? 'active' : ''} onClick={() => setActiveVariation(variant)}>{variant.name}</span>
                                </div>
                            })}
                        </div>}

                        {/* <div className="prod-pdp-sizetitle">Size</div> */}
                        {(item?.benefits || item?.howToUse || item?.ingredients) && <div className="fullwidth">
                            {item?.benefits && <Accordion>
                                <AccordionSummary
                                    expandIcon={<IconFrame><ExpandIcon /></IconFrame>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header">
                                    <div className="accor-title">{languageData["Features & Benefits"] ? languageData["Features & Benefits"] : "Features & Benefits"}</div>
                                </AccordionSummary>
                                <AccordionDetails className="description">
                                    {item?.languages && item.languages[activeLanguage?.languageId]?.benefits ? item.languages[activeLanguage?.languageId]?.benefits : item?.benefits}
                                </AccordionDetails>
                            </Accordion>}

                            {item?.ingredients && <Accordion>
                                <AccordionSummary
                                    expandIcon={<IconFrame><ExpandIcon /></IconFrame>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header">
                                    <div className="accor-title">{languageData["Ingredients"] ? languageData["Ingredients"] : "Ingredients"}</div>
                                </AccordionSummary>
                                <AccordionDetails className="description">
                                    {item?.languages && item.languages[activeLanguage?.languageId]?.ingredients ? item.languages[activeLanguage?.languageId]?.ingredients : item?.ingredients}
                                </AccordionDetails>
                            </Accordion>}
                            {item?.howToUse && <Accordion>
                                <AccordionSummary
                                    expandIcon={<IconFrame><ExpandIcon /></IconFrame>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header">
                                    <div className="accor-title">{languageData["How To Use"] ? languageData["How To Use"] : "How To Use"}</div>
                                </AccordionSummary>
                                <AccordionDetails className="description">
                                    {item?.languages && item.languages[activeLanguage?.languageId]?.howToUse ? item.languages[activeLanguage?.languageId]?.howToUse : item?.howToUse}
                                </AccordionDetails>
                            </Accordion>}
                            <div className="common-15height"></div>
                        </div>}
                    </div>
                    {(configData?.orderingOn && !configData?.storeOff && !configData?.readOnlyMenu) ? <div className="itemcounter">
                        {(configData?.storeConfig?.basicConfig?.inventory ? true : false) ? <>
                            {(configData?.storeConfig?.basicConfig?.inventory && currentStock != 0) && <div className="current-stock-wrap" id="current-stock-wrap">
                                {currentStock <= 10 ? <>{languageData["Only"] ? languageData["Only"] : "Only"} {currentStock} {languageData["left in stock order soon"] ? languageData["left in stock order soon"] : "left in stock order soon"}!</> : <>
                                    {currentStock <= 15 ? <>{languageData["Only Few Left"] ? languageData["Only Few Left"] : "Only Few Left"}!</> : <></>}
                                </>}
                            </div>}
                            {quantity == 0 ?
                                <>
                                    {currentStock ?
                                        <><div className="addtocartbtn" onClick={addItemToCart}>{languageData["Add to cart"] ? languageData["Add to cart"] : "Add to cart"}</div>
                                        </> : <div className="addtocartbtn stock-unavailable"> {languageData["Currently unavailable"] ? languageData["Currently unavailable"] : "Currently unavailable"}</div>}
                                </>
                                :
                                <div className="itemcounterinner">
                                    <div className="counterbuttons">
                                        <button className="countclick"
                                            onClick={removeQuantity}>-</button>
                                        <div className="countnum">
                                            {quantity}
                                        </div>
                                        <button className="countclick"
                                            onClick={addQuantity}>+</button>
                                    </div>
                                </div>}
                        </> : <>
                            {quantity == 0 ?
                                <div className="addtocartbtn" onClick={addItemToCart}>{languageData["Add to cart"] ? languageData["Add to cart"] : "Add to cart"}</div>
                                :
                                <div className="itemcounterinner">
                                    <div className="counterbuttons">
                                        <button className="countclick"
                                            onClick={removeQuantity}>-</button>
                                        <div className="countnum">
                                            {quantity}
                                        </div>
                                        <button className="countclick"
                                            onClick={addQuantity}>+</button>
                                    </div>
                                </div>}
                        </>}
                        <>
                            {configData?.storeConfig?.sparkConfig?.quoteRequest && <div className={`request-quote-btn addtocartbtn ${quoteReqSubmitted ? 'disabled' : ''}`} onClick={checkForUser}>{quoteReqSubmitted ? `${languageData["Quote request sent"] ? languageData["Quote request sent"] : "Quote request sent"}` : `${languageData["Get quote"] ? languageData["Get quote"] : "Get quote"}`}</div>}
                        </>
                    </div> : <>
                        {configData?.storeConfig?.sparkConfig?.quoteRequest && <div className="itemcounter">
                            <div className={`addtocartbtn ${quoteReqSubmitted ? 'disabled' : ''}`} onClick={checkForUser}>{quoteReqSubmitted ? `${languageData["Quote request sent"] ? languageData["Quote request sent"] : "Quote request sent"}` : `${languageData["Get quote"] ? languageData["Get quote"] : "Get quote"}`}</div>
                        </div>}
                    </>}
                </div>
            </div>
            <Backdrop
                className="backdrop-modal-wrapper"
                open={showVdoModal ? true : false}
            >
                <div className="vdo-details-backdrop-wrap backdrop-modal-content"
                    style={{ height: `${showVdoModal ? '480px' : '0'}` }}
                >
                    <div className="modal-close" onClick={() => setShowVdoModal(false)}>
                        <IconFrame><CloseLargeIcon /></IconFrame>
                    </div>
                    <div className='d-f-c vdo-details-frame'>
                        {showVdoModal && <iframe className="vdo-frame" src={item?.videoLink} width="640" height="480" allow="autoplay"></iframe>}
                        {/* {showVdoModal && <iframe className="vdo-frame" src={item?.videoLink} width="640" height="480" allow="autoplay"></iframe>} */}
                    </div>
                </div>
            </Backdrop>
            <Backdrop
                className="backdrop-modal-wrapper"
                open={openShareModal ? true : false}
                onClick={() => setOpenShareModal(false)}
            >
                <div className="backdrop-modal-content social-sharing-modal"
                    style={{ height: `${openShareModal ? `315px` : '0'}` }}
                >
                    <div className="heading" >{languageData["Share"] ? languageData["Share"] : "Share"} </div>
                    <div className="modal-close" onClick={() => setOpenShareModal(false)}>
                        <IconFrame><CloseLargeIcon /></IconFrame>
                    </div>
                    <div className='pricing-details-wrap'>
                        <div className="preview-wrap" onClick={() => onClickSocialIcon({ name: 'Copy Link' })}>
                            {!!(item?.pImage || (item?.imagePaths && item?.imagePaths?.length != 0 ? item?.imagePaths[0].imagePath : '')) && <div className="img-wrap">
                                <img src={item?.pImage || (item?.imagePaths && item?.imagePaths?.length != 0 ? item?.imagePaths[0].imagePath : '')} alt={item.name} />
                            </div>}
                            <div className="title-wrap">
                                <div className="title">{item?.pTitle || item?.name}</div>
                                <div className="desc">{item?.pDescription || item?.description}</div>
                            </div>
                        </div>
                        <div className="icons-list">
                            {shareIconList.map((shareData: any, index: number) => {
                                return <div className="icon-wrap" key={index} onClick={() => onClickSocialIcon(shareData)}>
                                    <div className="icon">{shareData.icon}</div>
                                    <div className="name">{shareData.name}</div>
                                </div>
                            })}
                            <div >
                            </div>
                        </div>
                    </div>
                </div>
            </Backdrop>
            {showUserRegistrationModal && <UserRegistrationModal
                fromPage={'PDP'}
                handleResponse={(e) => onLoginClose(e)}
                isApppGrpChangeOnUserGdrChange={showUserRegistrationModal ? true : false}
                open={true}
                heading={'Login to send quote request'} />}
        </>

    );
}

export default PdpModal;